// UserByUsername.js
'use client';
import { connect } from 'react-redux';

import withRouter from '../component/WithRouter.jsx';

import fetchUserByUsername from '../action/fetchUserByUsername.js';
import getUserDataByUsername from '../selector/getUserDataByUsername.js';
import getNetworkingData from '../selector/getNetworkingData.js';
import getMeData from '../selector/getMeData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import UserByUsername from '../page/UserByUsername.jsx';

import { USER_PROFILE_TABS } from '../RemoteConfigKeys.js';

const mapStateToProps = (
  state,
  {
    match: {
      params: {
        username,
        listType: paramListType,
        publishStatus: paramPublishStatus,
      } = {},
    } = {},
  }
) => {
  const listType =
    paramListType || getRemoteConfigData(state, USER_PROFILE_TABS)[0];
  return {
    username,
    listType,
    publishStatus: paramPublishStatus,
    isAuthed: !!getMeData(state, 'id'),
    userId: getUserDataByUsername(state, username, 'id'),
    isFetching: getNetworkingData(state, ['user', username], 'isFetching'),
    fetchError: getNetworkingData(state, ['user', username], 'error'),
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchUserByUsername: ({ username, httpProxyHeaders }) =>
      dispatch(fetchUserByUsername({ username, httpProxyHeaders })),
  };
};

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(UserByUsername)
);
